// extracted by mini-css-extract-plugin
module.exports = {"myModal":"BottomDrawer_myModal___5xpv","mymodalSlideIn":"BottomDrawer_mymodalSlideIn__3dsME","mymodalSlideOut":"BottomDrawer_mymodalSlideOut__AzM_G"};